// test2642
(2642 && 0);
